<template>
    <div>
    </div>
</template>

<script>
    import axios from 'axios'
    import env from '../../common/js/env'
    import {reqPwdLogin, reqRegister} from '../../api'

    export default {
        name: 'wxauth',
        created() {
            /**
             * 微信网页授权
             */
			console.log(this.$route);
                //保存当前路由地址，授权后还会跳到此地址
            let companyId = this.$route.params.companyId;
            if (this.$route.query.t) {
                this.$cookies.set('t', this.$route.query.t)
            }
            if (companyId) {
                this.$cookies.remove('companyId')
                this.$cookies.set('companyId', companyId)
                const MAInmpappid = params => {
                    return axios.get('/api/common/mpappid/' + params)
                        .then(res => res.data);
                };
                MAInmpappid(companyId).then(res => {
                    if (res.success) {
                        if (res.data.length == 0) {
                            alert('服务暂未开通！');
                            setTimeout(function () {
                                //这个可以关闭安卓系统的手机
                                document.addEventListener(
                                    "WeixinJSBridgeReady",
                                    function () {
                                        parent.WeixinJSBridge.call("closeWindow");
                                    },
                                    false
                                );
                                //这个可以关闭ios系统的手机
                                // if (WeixinJSBridge.call) {
                                //     parent.WeixinJSBridge.call("closeWindow");
                                // }
                            }, 300);
                            return false
                        }
                        //请求微信授权,并跳转到 /WxAuth 路由
                        let redirectUrl = encodeURIComponent(env.authUrl + 'auth/' + companyId)
                        let appId = res.data[0].appId
                        this.$cookies.remove('mpappid')
                        this.$cookies.set('mpappid', res.data)
						window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&connect_redirect=1&response_type=code&scope=snsapi_userinfo&state=${companyId}#wechat_redirect`
                    } else {
                        alert(res.msg);
                    }
                }).catch(error => {
                    alert(error + '系统繁忙，请稍后重试！');
                })
            }
        }
    }
</script>

<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/pages/Wxauth/Wxauth.vue